export default "__VITE_ASSET__DXxurOxf__"